import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { useAppSelector } from '../../data/store'
import { appSelectors } from '../../data/store/AppStore'
import { creditApplicationEffects, creditApplicationSelectors } from '../../data/store/CreditApplicationStore'
import { useSideEffect } from '../../data/store/Effects/side-effects'
import { CustomerFeedback } from '../../data/types/CustomerFeedback'
import FeedbackOption from './FeedbackOption'

function CustomerFeedbackPage() {
  const { t } = useTranslation()
  const { id } = useParams()
  const dispatchEffect = useSideEffect()
  const navigate = useNavigate()

  const withdrawalReasons = useAppSelector(appSelectors.getWithdrawalReasons)
  const [selectedReason, setSelectedReason] = useState('')
  const [isDialogOpen, setDialogOpen] = useState(false)
  const [contactConfirmation, setContactConfirmation] = useState(false)
  const currentMerchantId = useAppSelector(creditApplicationSelectors.getCurrentMerchantId)

  const cancelMyApp = () => {
    dispatchEffect(creditApplicationEffects.putCancelCreditApplication(id as string))
  }

  const buildSelectedWithdrawalReasonFeedbackDto = (contactClient: boolean): CustomerFeedback => ({
    withdrawalReasonId: selectedReason,
    contactClient,
    isSatisfied: false,
    badReviewReasonId: '',
  })

  const handleReasonSelected = (withdrawId: string) => {
    setSelectedReason(withdrawId)
  }
  const handleSubmit = (event: { preventDefault: () => void }) => {
    const dto = buildSelectedWithdrawalReasonFeedbackDto(false)
    if (withdrawalReasons.find((x) => x.id === selectedReason && x.contactClient === true)) {
      setDialogOpen(true)
    } else {
      cancelMyApp()
      dispatchEffect(creditApplicationEffects.postCustomerFeedback(dto, id as string)).then(() =>
        navigate(`/${currentMerchantId}`, { replace: true }),
      )
    }

    event.preventDefault()
  }

  const handleConfirmation = (contactClient: boolean) => {
    const dto = buildSelectedWithdrawalReasonFeedbackDto(contactClient)
    if (!contactClient) {
      cancelMyApp()
      dispatchEffect(creditApplicationEffects.postCustomerFeedback(dto, id as string)).then(() =>
        navigate(`/${currentMerchantId}`, { replace: true }),
      )
    } else {
      setContactConfirmation(true)
      dispatchEffect(creditApplicationEffects.postCustomerFeedback(dto, id as string))
    }
  }

  return (
    <main className="form-section">
      <form onSubmit={handleSubmit} style={{ textAlign: 'center', marginTop: '-10%' }}>
        {!isDialogOpen && !contactConfirmation && (
          <div className="control-group">
            <h1 style={{ margin: '2rem auto' }}>{t('customerFeedback.formTitle')}</h1>
            <div className="paragraphe">
              <p style={{ margin: '3rem auto' }}>{t('customerFeedback.formSubtitle')}</p>
            </div>
            {withdrawalReasons?.map((r) => (
              <FeedbackOption
                key={r.id}
                id={r.id}
                text={r.text}
                selected={selectedReason}
                onChange={handleReasonSelected}
              />
            ))}
            <div style={{ textAlign: 'end' }}>
              <button type="submit" className="btn btn-blue" disabled={false} style={{ margin: '1rem auto' }}>
                <span>{t('common.submit')}</span>
                <i className="fa-regular fa-arrow-right" />
              </button>
            </div>
          </div>
        )}
      </form>
      {isDialogOpen && !contactConfirmation && (
        <div style={{ textAlign: 'center', marginTop: '30%' }}>
          <h1>{t('customerFeedback.confirmation')}</h1>
          <button
            type="submit"
            className="btn btn-blue"
            disabled={false}
            onClick={() => handleConfirmation(true)}
            style={{ margin: '2rem 1rem 2rem 0', marginRight: '1rem', width: '100px', justifyContent: 'center' }}
          >
            {t('common.yes')}
          </button>
          <button
            type="submit"
            className="btn btn-blue"
            disabled={false}
            onClick={() => handleConfirmation(false)}
            style={{
              margin: '2rem 1rem 2rem 0',
              marginRight: '1rem',
              width: '100px',
              justifyContent: 'center',
            }}
          >
            {t('common.no')}
          </button>
        </div>
      )}
      {contactConfirmation && (
        <div style={{ textAlign: 'center', marginTop: '30%' }}>
          <h1>{t('customerFeedback.customerConfirmation')}</h1>
          <button
            type="submit"
            className="btn btn-blue"
            disabled={false}
            onClick={() => window.location.reload()}
            style={{ margin: '2rem 1rem 2rem 0', marginRight: '1rem', justifyContent: 'center' }}
          >
            {t('customerFeedback.return')}
          </button>
        </div>
      )}
    </main>
  )
}

export default CustomerFeedbackPage
